import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck, faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './PayCheck.css';
import paycheckimage from '../../assets/pageimages/PayCheck.webp';

function PayCheckHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>PayCheck</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/paycheck-itemlist" className="top-button-link"><FontAwesomeIcon icon={faList} className="paycheck-bottomlink-style" />Items List</Link></div>
              <div className="bottom-buttons-box"><Link to="/paycheck-createcode" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="paycheck-bottomlink-style" />Generate Code</Link></div>
              <div className="bottom-buttons-box"><Link to="/paycheck-fakereport" className="top-button-link"><FontAwesomeIcon icon={faListUl} className="paycheck-bottomlink-style" />Fake Report</Link></div>
              <div className="bottom-buttons-box"><Link to="/paycheck-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="paycheck-bottomlink-style" />PayCheck Scan</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="paycheck-id" src={paycheckimage} alt="PayCheck Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default PayCheckHome;
